import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { PermissionScopeResponse } from "~types/permissionScope";

const useGetUserPermissionScope = (permissionId: number | undefined, isEnabled: boolean) => {
  const request = useApi();
  const { organizationId, sport, userId } = useParams();

  return useQuery({
    queryKey: ["permission-scope", sport, organizationId, userId, permissionId],
    queryFn: () =>
      request<PermissionScopeResponse>(`${sport}/o/${organizationId}/users/${userId}/permissions/${permissionId}/scope`).then(
        (response: PermissionScopeResponse) => ({
          scope: response.data?.[0],
          resources: response.includes?.resources,
        }),
      ),
    enabled: isEnabled,
  });
};

export default useGetUserPermissionScope;
